import { motion } from "framer-motion";
import { UserPlus, FileText, PackageCheck } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

export default function HowItWorks() {
  const { t } = useLanguage();
  const steps = [
    { icon: UserPlus, title: t("home.step1_title", "Choisissez votre réseau"), desc: t("home.step1_desc", "Sélectionnez le réseau social et le service souhaité.") },
    { icon: FileText, title: t("home.step2_title", "Renseignez votre profil"), desc: t("home.step2_desc", "Indiquez votre nom d'utilisateur ou URL.") },
    { icon: PackageCheck, title: t("home.step3_title", "Recevez vos résultats"), desc: t("home.step3_desc", "Livraison rapide et sécurisée après paiement.") },
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-zinc-950/40" data-testid="how-it-works-section">
      <div className="mx-auto max-w-6xl">
        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-14 text-center">{t("home.how_it_works_title", "Comment ça marche")}</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((s, i) => (
            <motion.div key={s.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }} className="glass rounded-2xl p-8 relative">
              <div className="absolute -top-4 -left-1 font-heading text-6xl font-black text-white/5">{i + 1}</div>
              <div className="w-12 h-12 rounded-xl bg-indigo-500/15 flex items-center justify-center mb-5">
                <s.icon className="w-6 h-6 text-indigo-400" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-white mb-2">{s.title}</h3>
              <p className="text-sm text-zinc-500">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
